<div class="weather-menu-content">
    <div class="weather-header p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0">{{ 'layout.header.weather.title' | translate }}</h6>
    </div>

    <div class="weather-current p-x-24 p-y-16">
        <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center gap-12">
                <app-icon class="large" [icon]="data().today.icon"
                    [customClass]="getWeatherIconColor(data().today.icon)"></app-icon>
                <div>
                    <h6 class="f-s-16 f-w-600 m-b-4">{{ 'layout.header.weather.today' | translate }}</h6>
                    <p class="f-s-13 text-muted m-0">{{ data().today.condition | translate }}</p>
                </div>
            </div>
            <div class="text-right">
                <div class="f-s-36 f-w-700 lh-1">{{ data().today.temperature }}</div>
                <div class="f-s-12 text-muted m-t-4 d-flex align-items-center justify-content-end gap-8">
                    <span class="d-flex align-items-center gap-2">
                        <app-icon icon="solar:arrow-down-linear" customClass="f-s-16 text-info"></app-icon>
                        <span>{{ data().today.temperatureMin }}°</span>
                    </span>
                    <span class="d-flex align-items-center gap-2">
                        <app-icon icon="solar:arrow-up-linear" customClass="f-s-16 text-error"></app-icon>
                        <span>{{ data().today.temperatureMax }}°</span>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="weather-forecast">
        @for (day of data().forecast; track day.name) {
            <div class="forecast-item p-x-24 p-y-8">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center gap-16">
                        <app-icon class="large" [icon]="day.icon"
                            [customClass]="getWeatherIconColor(day.icon)"></app-icon>
                        <span class="f-s-14 f-w-500">{{ day.name | translate }}</span>
                    </div>
                    <span class="f-s-14 f-w-600">{{ day.temperature }}</span>
                </div>
            </div>
        }
    </div>
</div>